import { TextModel } from '../primitive/text.model';
import { DateModel } from '../primitive/date.model';
import { ConfigConstants } from '../../config/config-constants';
import { CompositeModel } from './composite.model';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { DateModelOptions } from '../options/date-model-options';
import moment from 'moment';
import { isDefined } from '../../utilities/is-defined';
import { TextModelOptions } from '../options/text-model-options';

export class ComponentInformationModel extends CompositeModel {
    public manufacturer: TextModel;
    public modelNumber: TextModel;
    public manufacturedDate: DateModel;

    public constructor(
        public manufacturerKey = '',
        public manufacturerValue = '',
        public modelKey = '',
        public dateKey = '',
    ) {
        super('ComponentInformationModel');
        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);

        this.manufacturer = <TextModel>(
            this.set(new TextModel(manufacturerKey, manufacturerValue, new TextModelOptions({ readonly: true })))
        );
        modelOptionsLoader.load(this.manufacturer, 'Fda2579Form', 'ComponentManufacturer');

        this.modelNumber = <TextModel>this.set(new TextModel(modelKey));
        modelOptionsLoader.load(this.modelNumber, 'Fda2579Form', 'ComponentModelNumber');

        const dateModelOption = new DateModelOptions({
            format: ConfigConstants.formatPatternMonthYear,
            displayOnlyMonthYear: true,
            required: !!this.modelNumber.value,
            readonly: !this.modelNumber.value,
        });
        this.manufacturedDate = <DateModel>this.set(new DateModel(dateKey, moment.invalid(), dateModelOption));
    }

    public toJSON(): JsonComponentInformationModel {
        return {
            manufacturer: this.manufacturer.value,
            modelNumber: this.modelNumber.value,
            manufacturedDate: this.manufacturedDate.value,
            manufacturerKey: this.manufacturerKey,
            modelKey: this.modelKey,
            dateKey: this.dateKey,
        };
    }
}

export class ComponentInformationFromJson extends ComponentInformationModel {
    public constructor(data: JsonComponentInformationModel) {
        super(data.manufacturerKey, data.manufacturer, data.modelKey, data.dateKey);
        this.manufacturer.value = data.manufacturer;
        this.modelNumber.value = data.modelNumber;
        this.manufacturedDate.value = isDefined(data.manufacturedDate)
            ? moment(data.manufacturedDate)
            : moment.invalid();
    }
}

export interface JsonComponentInformationModel {
    manufacturer: string;
    modelNumber: string;
    manufacturedDate: moment.Moment;
    manufacturerKey: string;
    modelKey: string;
    dateKey: string;
}
